// IMPORTS

import App from './App'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
// ROOT
const root = ReactDOM.createRoot(document.getElementById('root'))

// PROVIDER
root.render(
  <BrowserRouter>
    <link
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css"
      rel="stylesheet"
      type="text/css"
    ></link>
    <App />
  </BrowserRouter>,
)
